// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3fe2x","topBottomGutter":"Layout_topBottomGutter__2dql_"};